
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Bien que les socialistes restent la deuxième force au sein du Conseil national, ils perdent encore 2,2% de voix et se situent désormais à 16,6%. Le PS perd deux sièges à Zurich et à Berne. La forte hausse dans le canton d'Uri s'explique par le fait que, contrairement aux élections de 2015, il y avait cette année un candidat du PS aux élections du Conseil national (mais sans succès).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;